import { useEffect } from "react";
export var useScrollLock = function () {
    useEffect(function () {
        document.body.classList.add("modal-open");
        return function () {
            document.body.classList.remove("modal-open");
        };
    }, []);
};
